
export default ({
    data() {
        return {
        }
    },
    // props: {
    // },
});
